import axiosInstance from './axiosInstance';
import {useFormik} from 'formik';
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import { CONFIG_SERVICE_ID } from "../const/configConst";

function ConfigEdit() {
    const params = useParams();
    const [isLoading, setLoading] = useState(false);
    const [featureList, setFeatureList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [domainList, setDomainList] = useState([]);
    const navigate = useNavigate();

    const fetchDomainList = async () => {
        try {
            const response = await axiosInstance.get(`/domains/list`);
            const domains = response.data?.data || [];
            setDomainList(domains);
        } catch (error) {
            console.error('Error fetching domain list:', error);
            setDomainList([]);
        }
    };

    const fetchFeatureList = async (domain) => {
        try {
            let featureListResult = [];
            if (domain) {
                const response = await axiosInstance.get(`/domains/list?domain=${domain}`);
                featureListResult = response.data?.data || [];
            } else {
                featureListResult = domainList;
            }
            const mergedFeatureList = featureListResult.reduce((acc, domain) => {
                if (domain.feature_list && Array.isArray(domain.feature_list)) {
                    // Add unique features only
                    domain.feature_list.forEach(feature => {
                        if (!acc.includes(feature)) {
                            acc.push(feature);
                        }
                    });
                }
                return acc;
            }, []);
            setFeatureList(mergedFeatureList);
        } catch (error) {
            console.error('Error fetching feature list:', error);
            setFeatureList([]);
        }
    };

    const fetchServiceList = async (domain) => {
        try {
            let serviceListResult = [];
            if (domain) {
                const response = await axiosInstance.get(`/domains/list?domain=${domain}`);
                serviceListResult = response.data?.data || [];
            } else {
                serviceListResult = domainList;
            }
            const mergedServiceList = serviceListResult.reduce((acc, domain) => {
                if (domain.service_code && Array.isArray(domain.service_code)) {
                    // Add unique services only
                    domain.service_code.forEach(service => {
                        if (!acc.includes(service)) {
                            acc.push(service);
                        }
                    });
                }
                return acc;
            }, []);
            setServiceList(mergedServiceList);
        } catch (error) {
            console.error('Error fetching service list:', error);
            setServiceList([]);
        }
    };

    const myFormik = useFormik({
        initialValues: {
            domain: "",
            code: "",
            main_service: "",
            backup_service: "",
            api_key: "",
            free_usage_per_day: 0,
            content_type: "",
            backup_service_countries: "",
            disable_countries: "",
        },
        validate: (values) => {
            return {};
        },
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const formData = new FormData();
                formData.append("code", values.code);
                formData.append("main_service", values.main_service);
                formData.append("backup_service", values.backup_service);
                formData.append("api_key", values.api_key == null ? "" : values.api_key);
                formData.append("free_usage_per_day", values.free_usage_per_day == null ? 0 : parseInt(values.free_usage_per_day, 10));
                formData.append("content_type", values.content_type == null ? "" : values.content_type);
                formData.append("backup_service_countries", values.backup_service_countries === "null" ? "" : values.backup_service_countries);
                formData.append("disable_countries", values.disable_countries === "null" ? "" : values.disable_countries);
                formData.append("domain", values.domain);
                await axiosInstance.post(`/config/update/${params.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                setLoading(false);
                navigate("/portal/config-list")
            } catch (error) {
                setLoading(false);
            }
        }
    });

    useEffect(() => {
        fetchDomainList();
        getConfigData().then(() => {})
    }, []);

    useEffect(() => {
        fetchFeatureList(myFormik.values.domain);
        fetchServiceList(myFormik.values.domain);
    }, [myFormik.values.domain, domainList]);

    let getConfigData = async () => {
        try {
            const res = await axiosInstance.get(`/config/detail/${params.id}`);
            const config = res.data?.data ?? []
            if (!config) {
                navigate("/portal/config-list")
            } else {
                // Transform null values to empty strings
                const transformedConfig = {
                    ...config,
                    backup_service_countries: config.backup_service_countries === "null" ? "" : config.backup_service_countries,
                    disable_countries: config.disable_countries === "null" ? "" : config.disable_countries
                };
                await myFormik.setValues(transformedConfig);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            navigate("/portal/config-list")
        }
    }

    return (
        <>
            <h3>Config - Id : {params.id} </h3>
            <div className='container'>
                <form onSubmit={myFormik.handleSubmit}>
                    <div className='row'>
                        <div className="col-lg-6">
                            <label className='font-weight-bold'>Domain</label>
                            <select
                              name='domain'
                              value={myFormik.values.domain}
                              onChange={myFormik.handleChange}
                              className={`form-control ${myFormik.errors.domain ? "is-invalid" : ""}`}
                            >
                                <option value="">----Select----</option>
                                {domainList.map((domain, index) => (
                                  <option key={index} value={domain.code}>{domain.code} ({domain.domain})</option>
                                ))}
                            </select>
                            <span style={{ color: "red" }}>{myFormik.errors.domain}</span>
                        </div>

                        <div className="col-lg-6">
                            <label className='font-weight-bold'>Feature Name</label>
                            <select
                              name='code'
                              value={myFormik.values.code}
                              onChange={myFormik.handleChange}
                              className={`form-control ${myFormik.errors.code ? "is-invalid" : ""}`}
                            >
                                <option value="">----Select----</option>
                                {featureList.map((feature, index) => (
                                    <option key={index} value={feature}>
                                        {feature.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                    </option>
                                ))}
                            </select>
                            <span style={{ color: "red" }}>{myFormik.errors.code}</span>
                        </div>

                        <div className='col-lg-6'>
                            <label className='font-weight-bold'>Main Service</label>
                            <select
                              name='main_service'
                              value={myFormik.values.main_service}
                              onChange={myFormik.handleChange}
                              className={`form-control ${myFormik.errors.main_service ? "is-invalid" : ""}`}
                            >
                                <option value="">----Select----</option>
                                {serviceList.map((service, index) => (
                                  <option key={index} value={service}>{service}</option>
                                ))}
                            </select>
                            <span style={{ color: "red" }}>{myFormik.errors.main_service}</span>
                        </div>

                        <div className='col-lg-6'>
                            <label className='font-weight-bold'>Backup Service</label>
                            <select
                              name='backup_service'
                              value={myFormik.values.backup_service}
                              onChange={myFormik.handleChange}
                              className={`form-control ${myFormik.errors.backup_service ? "is-invalid" : ""}`}
                            >
                                <option value="">----Select----</option>
                                {serviceList.map((service, index) => (
                                  <option key={index} value={service}>{service}</option>
                                ))}
                            </select>
                            <span style={{ color: "red" }}>{myFormik.errors.backup_service}</span>
                        </div>

                        {/*<div className="col-lg-6">
                            <label className='font-weight-bold'>API Key</label>
                            <input
                              name='api_key'
                              value={myFormik.values.api_key}
                              onChange={myFormik.handleChange}
                              type="text"
                              className={`form-control ${myFormik.errors.api_key ? "is-invalid" : ""}`}
                            />
                            <span style={{ color: "red" }}>{myFormik.errors.api_key}</span>
                        </div>*/}

                        {/*<div className='col-lg-6'>
                            <label className='font-weight-bold'>Always Show Offer</label>
                            <input
                              type="checkbox"
                              name="always_show_offer"
                              checked={myFormik.values.always_show_offer}
                              onChange={myFormik.handleChange}
                              className='form-check-input ml-2'
                            />
                            <span style={{ color: "red" }}>{myFormik.errors.always_show_offer}</span>
                        </div>*/}

                        <div className='col-lg-6'>
                            <label className='font-weight-bold'>Free Usage Per Day</label>
                            <input
                              name='free_usage_per_day'
                              value={myFormik.values.free_usage_per_day}
                              onChange={myFormik.handleChange}
                              type="number"
                              className={`form-control ${myFormik.errors.free_usage_per_day ? "is-invalid" : ""}`}
                            />
                            <span style={{ color: "red" }}>{myFormik.errors.free_usage_per_day}</span>
                        </div>

                        <div className='col-lg-6'>
                            <label className='font-weight-bold'>Content Type</label>
                            <select
                              name='content_type'
                              value={myFormik.values.content_type}
                              onChange={myFormik.handleChange}
                              className={`form-control ${myFormik.errors.content_type ? "is-invalid" : ""}`}
                            >
                                <option value="">----Select----</option>
                                {["ad", "iap", "none"].map((service, index) => (
                                  <option key={index} value={service}>{service}</option>
                                ))}
                            </select>
                            <span style={{ color: "red" }}>{myFormik.errors.content_type}</span>
                        </div>

                        <div className="col-lg-6">
                            <label className='font-weight-bold'>Backup Service Countries</label>
                            <input
                              name='backup_service_countries'
                              value={myFormik.values.backup_service_countries}
                              onChange={myFormik.handleChange}
                              type="text"
                              className={`form-control ${myFormik.errors.backup_service_countries ? "is-invalid" : ""}`}
                            />
                            <span style={{ color: "red" }}>{myFormik.errors.backup_service_countries}</span>
                        </div>

                        <div className="col-lg-6">
                            <label className='font-weight-bold'>Disable Countries</label>
                            <input
                              name='disable_countries'
                              value={myFormik.values.disable_countries}
                              onChange={myFormik.handleChange}
                              type="text"
                              className={`form-control ${myFormik.errors.disable_countries ? "is-invalid" : ""}`}
                            />
                            <span style={{ color: "red" }}>{myFormik.errors.disable_countries}</span>
                        </div>

                        <div className='col-lg-12 mt-3'>
                            <input
                              disabled={isLoading}
                              type="submit"
                              value={isLoading ? "Submitting..." : "Save"}
                              className='btn btn-primary'
                            />
                        </div>
                    </div>
                </form>
                {/* {JSON.stringify(myFormik.values)} */}
            </div>
        </>


    )
}

export default ConfigEdit